import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/salesCopy';
export function Testimonials() {
  return <section className="bg-cream-deep py-12 sm:py-24" aria-labelledby="historias" data-id="element-149" data-mp="3kqw4qlswr4gn">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-150" data-mp="3fym8ko17985x">
        <h2 id="historias" className="max-w-2xl font-display text-[1.6rem] font-semibold leading-tight text-ink sm:text-4xl" data-id="element-151" data-mp="3b0kp41zv36tx">
          Mujeres que ya transformaron su vida con este método
        </h2>

        <ul className="mt-8 grid gap-4 sm:mt-12 sm:gap-6 md:grid-cols-3" data-id="element-152" data-mp="31zwab52n92fz">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-2xl bg-cream p-5 ring-1 ring-ink/10 sm:p-7" data-id="element-153" data-mp="2x0tbi2d9bsgg">
              <QuoteIcon aria-hidden="true" className="h-5 w-5 text-champagne sm:h-6 sm:w-6" data-id="element-154" data-mp="2s28gqigry0ze" />
              <blockquote className="mt-4 text-[15px] leading-relaxed text-ink/80 sm:mt-5 sm:text-base" data-id="element-155" data-mp="v9yfb9f51r97">
                “{item.quote}”
              </blockquote>
              <div className="mt-auto pt-5 sm:pt-7" data-id="element-156" data-mp="q896m0fe1poa">
                <div className="flex items-center gap-3" data-id="element-157" data-mp="h4wuw2gayci7">
                  <img src={item.avatar} alt={`Retrato de ${item.name}`} className="h-11 w-11 rounded-full object-cover" loading="lazy" data-id="element-158" data-mp="m51cjvsy5da0" />
                  <div data-id="element-159" data-mp="78tvh4cu4ryy">
                    <p className="font-medium text-ink" data-id="element-160" data-mp="79bqjxnrh05a">{item.name}</p>
                    <p className="text-xs text-ink/60" data-id="element-161" data-mp="c7wotrjgd9r3">
                      {item.role} · {item.country}
                    </p>
                  </div>
                </div>
                <p className="mt-4 border-t border-ink/10 pt-4 text-sm font-semibold text-rose" data-id="element-162" data-mp="14v9be1pm5hke">
                  {item.result}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}